import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import { TPartnerInformationPayload } from "@zeal/common";

export type TGetPartnerInfoParams = {
  whiteLabelID: string;
};

export const getPartnerInfo = (axios: IAxiosInstance) => {
  return async (
    params: TGetPartnerInfoParams
  ): Promise<TPartnerInformationPayload["partner"]> => {
    const { whiteLabelID } = params;
    const response = await axios.noRetry.get<
      IApiResponse<TPartnerInformationPayload["partner"]>
    >(`/api/partners/${whiteLabelID}/info`);
    const resData = response.data;
    if (resData.success && resData.data) {
      return resData.data;
    }
    throw new Error("Failed to get partner info");
  };
};
